import { Modal, Button, ListGroup } from 'react-bootstrap'
import { t } from '../locale'

type HistoryEntry = { datetime: string; user: string; value: any }
type SelectOption = { value: any; label: string }

export function HistoryModal({
  open,
  onHide,
  entries,
  title,
  options,
}: {
  open: boolean
  onHide: () => void
  entries: HistoryEntry[]
  title: string
  options?: SelectOption[]
}) {
  const resolveLabel = (value: any) => {
    if (options) {
      const match = options.find(o => String(o.value) === String(value))
      if (match) return match.label
    }
    return String(value)
  }

  return (
    <Modal show={open} onHide={onHide} centered backdrop='static' scrollable>
      <Modal.Header closeButton>
        <Modal.Title>
          {t('history')} — {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {entries?.length ? (
          <ListGroup variant='flush'>
            {entries.map((h, i) => (
              <ListGroup.Item key={i}>
                <div className='text-muted'>
                  {h.datetime} — {h.user}
                </div>
                <div>{resolveLabel(h.value)}</div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <div className='text-muted'>{t('noHistory')}</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          {t('close')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
